import ENDPOINTS from "../ApiManager/UsuarioEndPoints";
import environment from "../environments/environment";
import * as Constants from '../constants';

const BASE_URL = environment.api_url;

class UsuarioService {

	static getUsuarios = (establecimientoId, userRol) => {
		const url = BASE_URL + ENDPOINTS.GET_USUARIOS(establecimientoId, userRol)
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};

	static getTiposUsuarioByParams = (establecimientoId, activo, nombre, idTipo, userRol) => {
		const url = BASE_URL + ENDPOINTS.GET_TIPOS_USUARIO_BY_PARAMS(establecimientoId, activo, nombre, idTipo, userRol)
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};
	
	static getUsuarioById = (id) => {
		const url = BASE_URL + ENDPOINTS.GET_USUARIO_BY_ID(id)
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};
	
	
	static crearUsuario = (usuario) => {
		const tipoUsuario = usuario.idTipo.id;
		var url = BASE_URL;
		var body = JSON.stringify({
			nombre: usuario.nombre,
			idTipo: usuario.idTipo.id,
			apellidos: usuario.apellidos,
			email: usuario.email,
			telefono: usuario.telefono,
			password: usuario.password,
			nif: usuario.nif
		});

		if (tipoUsuario === Constants.ROLE_USUARIO_ADMINISTRADOR) {
			url += ENDPOINTS.CREATE_USUARIO_ADMIN();
		}

		if (tipoUsuario === Constants.ROLE_USUARIO_ADMIN_CADENA) {
			url += ENDPOINTS.CREATE_USUARIO_ADMIN_CADENA();

			body = JSON.stringify({
				nombre: usuario.nombre,
				idTipo: usuario.idTipo.id,
				apellidos: usuario.apellidos,
				email: usuario.email,
				telefono: usuario.telefono,
				password: usuario.password,
				cadena: usuario.cadena,
				nif: usuario.nif
			});
		}

		if (tipoUsuario === Constants.ROLE_USUARIO_GESTOR) {
			url += ENDPOINTS.CREATE_USUARIO_GESTOR();

			body = JSON.stringify({
				nombre: usuario.nombre,
				idTipo: usuario.idTipo.id,
				apellidos: usuario.apellidos,
				email: usuario.email,
				telefono: usuario.telefono,
				password: usuario.password,
				establecimiento: usuario.establecimiento.id,
				nif: usuario.nif
			});
		}

		if (tipoUsuario === Constants.ROLE_USUARIO_TRABAJADOR) {
			url += ENDPOINTS.CREATE_USUARIO_TRABAJADOR();

			body = JSON.stringify({
				nombre: usuario.nombre,
				idTipo: usuario.idTipo.id,
				apellidos: usuario.apellidos,
				email: usuario.email,
				telefono: usuario.telefono,
				password: usuario.password,
				establecimiento: usuario.establecimiento.id,
				tipoEmpleado: usuario.tipoEmpleado,
				nif: usuario.nif
			});
		}

		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: body
		});
	};

	static actualizarUsuario = (usuario) => {
		const tipoUsuario = usuario.idTipo;
		var url = BASE_URL;
		var body = JSON.stringify({
			nombre: usuario.nombre,
			apellidos: usuario.apellidos,
			email: usuario.email,
			telefono: usuario.telefono,
			activo: usuario.activo,
			nif: usuario.nif,
			password : usuario.password
		});

		if (tipoUsuario === Constants.ROLE_USUARIO_ADMINISTRADOR) {
			url += ENDPOINTS.UPDATE_USUARIO_ADMIN(usuario.id);
		}

		if (tipoUsuario === Constants.ROLE_USUARIO_ADMIN_CADENA) {
			url += ENDPOINTS.UPDATE_USUARIO_ADMIN_CADENA(usuario.id);
		}

		if (tipoUsuario === Constants.ROLE_USUARIO_GESTOR) {
			url += ENDPOINTS.UPDATE_USUARIO_GESTOR(usuario.id);
		}

		if (tipoUsuario === Constants.ROLE_USUARIO_TRABAJADOR) {
			url += ENDPOINTS.UPDATE_USUARIO_TRABAJADOR(usuario.id);
		}

		return fetch(url, {
			method: 'PUT',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: body
		});
	};

	static getTiposUsuario = () => {
		const url = BASE_URL + ENDPOINTS.GET_TIPOS_USUARIOS();
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}

		});
	};
	
	static getTiposUsuarioByUserRole = (role) => {
		const url = BASE_URL + ENDPOINTS.GET_TIPOS_USUARIO_BY_USER_ROLE(role)
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};


	static asignarHabitaciones = (idUsuario, listaHabitaciones) => {
		const url = BASE_URL + ENDPOINTS.ASIGNAR_HABITACIONES();
		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				usuario: idUsuario,
				listaHabitaciones: listaHabitaciones
			})
		});
	};
	
	static obtenerTokenPwd = (email) => {
		const url = BASE_URL + ENDPOINTS.OBTENER_TOKEN_PWD(email);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};
	
	static restablecerPwd = (password, token) => {
		const url = BASE_URL + ENDPOINTS.RESTABLECER_PWD(password, token);
		return fetch(url, {
			method: 'PUT',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			}
		});
	};

}

export default UsuarioService;